<!-- Main Page Start -->
<section class="loginPage">
  <div class="container">
      <div class="verificationWrap">
        <a href="javascript:void(0);" routerLink="/settings" class="bkbtn mb-2"><img src="assets/images/arrow_back.svg" class="ht"> Back</a>
          
          <h2 class="mainTitle"> Verification Code </h2>
          <p> To verify your identity. Please enter the OTP code we just sent to your email {{userData?.email}} </p>
          <form [formGroup]="form"> 
            <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" *ngIf="showOtpComponent" [config]="config"  (keypress)="preventNumbers($event)"></ng-otp-input>
            <div class="text-danger" *ngIf="showError">
              *Please enter otp.
            </div>
            <p *ngIf="!resendOtp"> Sending OTP in <span class="orangeText" id="timer"> {{display}} </span></p>
            <p *ngIf="resendOtp"> Didn’t receive the code? <a  href="javascript:void(0);" class="orangeText" (click)="resendOTP()"> Resend </a> </p>

              
             <div class="form-group">
                <input type="submit" value="Verify" (click)="verify()" class="commonBtn mt-5"> 
              </div>

          </form>

      </div>
  </div>
</section>

<!-- End -->